<template>
  <div>
    <button
      v-if="isComingSoonProduct"
      class="wf-add-to-cart-button btn btn-primary mb-3 pdp-quantity-and-size text-uppercase aside-sticky-button-width"
      @click="redirectToRepLocator"
    >
      <span class="ml-2">
        {{ $resourceString["pdp.button.contactyourrep"] }}
      </span>
    </button>
    <div
      class="description d-flex align-items-center mb-3"
      v-if="selectedColor.customPdqAvailable"
    >
      <span class="png-icon png-icon-icons-symbols--r-txtpdq-boxed"></span>
      <span class="ml-1">
        {{ $resourceString["product.details.aside.bottom.pdq.available"] }}
      </span>
    </div>

    <!-- Rugs -->
    <div
      class="description text-uppercase pdp-quantity-and-size bg-white mt-2"
      v-if="isRug"
    >
      <div
        class="rugs-select-size-block my-3 border-0 aside-sticky-button-width position-relative"
      >
        <div class="pdp-sample-size-options mt-3 mt-xl-0 mb-3">
          <button
            class="btn dropdown-toggle px-1"
            type="button"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <p class="m-0 px-2 option-display">
              {{ getSelectedOption }}
            </p>
            <span class="png-icon png-icon-icons-glyph--g-chevron-down"></span>
          </button>

          <div class="dropdown-menu w-100" aria-labelledby="dropdownMenuButton">
            <div
              class="option"
              v-for="(option, index) in rugsSizesOptions"
              :key="option.value"
              @click="changeRugs(option.value)"
              v-if="getSelectedOption != option.label"
            >
              <span v-if="getSelectedOption != option.label">{{
                option.label
              }}</span>
              <hr
                v-if="
                  rugsSizesOptions.length > 1 &&
                    index < rugsSizesOptions.length - 1 &&
                    getSelectedOption !== option.label
                "
              />
            </div>
          </div>
        </div>
        <a
          href="/RepLocator"
          class="d-block text-uppercase border border-dark p-2 my-3 text-dark text-decoration-none"
          >{{ $resourceString["product.details.aside.top.pricing.info"] }}</a
        >
      </div>
    </div>

    <div class="mb-4" v-if="!isComingSoonProduct && !isRug">
      <wf-add-to-cart-button
        :selling-style-number="sellingStyleNumber"
        :color-number="selectedColor.colorNumber"
        :trusted-user-flag="trustedUserDetails"
        :isPDP="true"
        cssClasses="btn btn-primary add-to-cart-mobile-button"
      >
      </wf-add-to-cart-button>
    </div>

    <div class="custom-description-container mb-4" v-if="customDescription">
      <span class="custom-description" v-html="customDescription"></span>
    </div>

    <div class="d-none d-lg-block">
      <div>
        <button
          @click="
            redirectTo3DSource(
              $helpers.getThreeDVisualizeUrl(
                getThreeDSourceURL,
                sellingStyleNumber,
                selectedColor.colorNumber,
                selectedInstallationMethod.name,
                getUserGUID
              )
            );
            $gtm.visualizeIn3dEvent();
          "
          class="pdp-mobile-three-d-btn custom-aside-bottom-button btn btn-light mb-3 aside-sticky-button-width"
          v-if="getVisibleThreeDButton && getEnable3DSource"
        >
          <img
            :src="getThreeDSourceIcon"
            class="mr-2 three-d-icon"
            width="26"
          />
          <span>{{ $resourceString["product.details.3DVisualize"] }}</span>
        </button>
      </div>
      <div v-if="chromaUrl && !isRug && !isResinous">
        <button
          v-if="chromaUrl && !isRug"
          class="w-100 mb-3 custom-aside-bottom-button btn btn-light customize-with-chroma-button aside-sticky-button-width justify-content-between"
          @click="redirectToChroma"
        >
          <span class="png-icon png-icon-icons-chroma-color"> </span>
          <span>
            {{
              $resourceString[
                "product.details.aside.bottom.customize.with.chroma"
              ]
            }}
          </span>
        </button>
      </div>
      <!-- Roomvo Visualizer -->
      <div v-if="isRoomvoVisualizerEnabled" class="roomvo-container" data-product-type-str="floor">
        <a
          href="javascript:;"
          class="roomvo-stimr w-100 custom-aside-bottom-button btn btn-light mb-3 aside-sticky-button-width"
          :data-sku="roomvoSku"
          style="visibility: hidden; cursor: pointer;"
        >
          <span class="png-icon png-icon-icons-glyph--k-btn-camera"></span>
          <span>{{ $resourceString['product.details.room.view.myspace'] }}</span>
        </a>
      </div>
    </div>

    <!-- For mobile & tablet -->
    <div class="row d-lg-none">
      <div class="col-6" v-if="(getVisibleThreeDButton && getEnable3DSource)">
        <span class="font-16 color-grey font-weight-normal text-uppercase d-block"
          >{{
            $resourceString["product.Details.Label.Visualize3D.Mobile"]
          }}
        </span>
        <button
          @click="
            redirectTo3DSource(
              $helpers.getThreeDVisualizeUrl(
                getThreeDSourceURL,
                sellingStyleNumber,
                selectedColor.colorNumber,
                selectedInstallationMethod.name,
                getUserGUID
              )
            );
            $gtm.visualizeIn3dEvent();
          "
          :disabled="!(getVisibleThreeDButton && getEnable3DSource)"
          :class="{ 'custom-aside-bottom-button': (getVisibleThreeDButton && getEnable3DSource) }"
          class="btn btn-light mb-3 aside-sticky-button-width w-100"
        >
          <img
            :src="getThreeDSourceIcon"
            class="mr-2 three-d-icon m-auto"
            width="25"
          />
          <span class="d-none d-lg-block">{{
            $resourceString["product.details.3DVisualize"]
          }}</span>
        </button>
      </div>

      <div class="col-6" v-if="isViewinmyroomEnabled">
        <span
          class="font-16 color-grey font-weight-normal text-uppercase d-block"
          >{{
            $resourceString["product.Details.Label.VisualizeMySpace.Mobile"]
          }}
        </span>
        <div class="roomvo-container" data-product-type-str="floor">
          <a
            href="javascript:;" 
            class="roomvo-stimr custom-aside-bottom-button btn btn-light mb-3 aside-sticky-button-width"
            :data-sku="roomvoSku"
            style="visibility: hidden; cursor: pointer;"
          >
            <span class="png-icon png-icon-icons-glyph--k-btn-camera"></span>
            <span>{{ $resourceString['product.details.room.view.myspace'] }}</span>
          </a>
        </div>
      </div>
      <div class="col-6" v-if="chromaUrl && !isRug && !isResinous">
      <span class="font-16 color-grey font-weight-normal text-uppercase d-block">
          {{
            $resourceString[
              "product.details.aside.bottom.customize.with.chroma"
            ]
          }}
        </span>
      <button
        v-if="chromaUrl && !isRug && !isResinous"
        class="w-100 custom-aside-bottom-button btn btn-light customize-with-chroma-button aside-sticky-button-width justify-content-between mb-3"
        @click="redirectToChroma"
      >
        <span class="png-icon png-icon-icons-chroma-color m-auto"> </span>
        <span class="d-none d-lg-block">
          {{
            $resourceString[
              "product.details.aside.bottom.customize.with.chroma"
            ]
          }}
        </span>
      </button>
    </div>
    <div
      class="col-6"
    >
    <span
          class="font-16 color-grey font-weight-normal text-uppercase d-block"
          >{{ $resourceString['product.Details.DownloadHD.Button'] }}
        </span>
      <button
        class="btn btn-white border-accent-gray-alt download-images-label bg-transparent w-100"
        for="download-images-select"
        @click="downloadButton()"
      >
        <span
          class="png-icon png-icon-icons-glyph--k-btn-download m-auto"
        ></span>

      </button>
    </div>
  </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import WFAddToCartButton from "../wf-add-to-cart-button.vue";
import PCProductAsideLink from "./pc-product-aside-link.vue";

export default {
  props: [
    "chromaUrl",
    "showViewInRoom",
    "trustedUserDetails",
    "isViewinmyroomEnabled",
    "isRoomvoVisualizerEnabled",
  ],
  components: {
    "wf-add-to-cart-button": WFAddToCartButton,
    "pc-product-aside-link": PCProductAsideLink
  },
  data() {
    return {
      showCard: false,
      title: null,
      description: null,
      sideMenuItems: [
        {
          title: "product.details.side.room.view.colors.label",
          anchor: "#room-section"
        },
        {
          title: "product.details.side.specs.sustainability.label",
          anchor: "#specs-section"
        },
        {
          title: "product.details.side.technical.documents.label",
          anchor: "#techs-section"
        },
        {
          title: "product.details.side.coordinating.products.label",
          anchor: "#coordinating-products"
        },
        {
          title: "product.details.side.inspiration.label",
          anchor: "#pc-inspiration-gallery"
        },
        {
          title: "product.details.side.lookbook.label",
          anchor: "#product-lookbook"
        }
      ]
    };
  },

  mounted() {
    this.fetchFullTypeSizeSamples();
  },
  methods: {
    ...mapActions({
      changeRugsSize: "productDetail/changeRugsSize",
      fetchFullTypeSizeSamples: "newBasketPage/fetchFullTypeSizeSamples"
    }),

    showModal(name) {
      this.$modal.show(name + "-modal");
    },

    downloadButton() {
        this.showModal("show-download-view");
    },

    changeRugs(value) {
      const newStyleNumber = value;
      this.changeRugsSize(newStyleNumber);
      const url = new URL(window.location);
      window.history.replaceState(
        null,
        null,
        `/product/detail/${
          this.selectedProduct?.styleNameURL
        }-${newStyleNumber}/${this.selectedColor?.colorNumber}${
          url?.searchParams ? "?" + url.searchParams?.toString() : ""
        }`
      );
    },
    redirectTo3DSource: function(url) {
      window.open(url, "_blank");
    },

    visualizerURL: function(url) {
      window.open(url, "_blank");
    },

    redirectToRepLocator() {
      window.location.href = "/RepLocator";
    },

    redirectToChroma() {
      window.open(`${this.chromaUrl}?q=${this.sellingStyleNumber}`, "_blank");
    },
  },
  computed: {
    ...mapGetters({
      selectedProduct: "productDetail/selectedProduct",
      rugsSizesOptions: "productDetail/rugsSizesOptions",
      selectedColor: "productDetail/color",
      productData: "productDetail/productData",
      sellingStyleNumber: "productDetail/sellingStyleNumber",
      isRug: "productDetail/isRug",
      isComingSoonProduct: "productDetail/isComingSoonProduct",
      customDescription: "productDetail/customDescription",
      images: "inspirationPage/images",
      getVisibleThreeDButton: "productDetail/getVisibleThreeDButton",
      getEnable3DSource: "productDetail/getEnable3DSource",
      getThreeDSourceURL: "productDetail/getThreeDSourceURL",
      selectedInstallationMethod: "productDetail/installationMethod",
      getUserGUID: "productDetail/getUserGUID",
      productVisualizerURL: "productDetail/productVisualizerURL",
      getThreeDSourceIcon: "productDetail/getThreeDSourceIcon"
    }),
    roomvoSku() {
      return encodeURIComponent(
        `${this.sellingStyleNumber}_${this.selectedColor?.colorNumber}`
      );
    },
    getSelectedOption() {
      const selectedOption = this.rugsSizesOptions?.find(
        option => option.value === this.sellingStyleNumber
      );
      return selectedOption ? selectedOption.label : "";
    },
    isResinous() {
      return (
        this.productData &&
        this.productData.inventoryType === this.$resourceString["resinous.InventoryType"]
      );
    },
  }
};
</script>
